import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/core/get/get.js";
import radio from "./radio.js";
import files from "./files.js";
import nav from "./navigation.js";
import mirror from "./mirror.js";
import recaptcha from "./recaptcha.js";
import scrape from "./scrape.js";
import tags from "./tags.js";
import table from "./table.js";
import submit from "./submit.js";
import copy from "../../../swgfl/javascript/copy.js";

export default (test = false) => {
	const form = $(".hashform");
	if (form.length) {
		const config = form.data("config"),
			upload = $("input[type=file][data-hash]", form);
		nav($("input[name=hashform-page]", form)); // controls the flow of the form
		radio($("[data-hashform]", form)); // moves to the appropriate screen based on answers
		files(upload, config, test); // processes images/videos that are selected
		mirror($("[data-mirror]", form)); // writes entered values into other places in the form
		copy($(".hashform__casenumber-copy", form)); // enables the case number to be copied
		scrape($("#hashform-control-urls", form), config); // bring in scrape results
		tags($("#hashform-tags", form), $(".ar-selectcontent", form), config); // tag images on their own device
		table($("#hashform-review", form), $("#hashform-table", form), config);
		submit(form, config); // submits hashes

		// only include recatcha for the old system
		const rc = $(".hashform__recaptcha", form);
		if (rc.length) {
			recaptcha(rc.get(0), config.recaptcha);
		}
	}
}